export default function initializeJobOffers() {
  document.querySelectorAll( '.block-job-offers' ).forEach( function( block ) {
    new JobOffers( block );
  } );
}

class JobOffers {
  block = null;
  baseHref = null;
  params = {
    search: null,
    location: null,
    list_page: 1,
    expand_offer: null,
  };
  listDOM = null;
  preloaderDOM = null;
  debugDOM = null;

  constructor( block ) {
    this.block = block;
    this.listDOM = block.querySelector( '.job-offers-list' );
    this.preloaderDOM = block.querySelector( '.preloader' );
    this.debugDOM = block.querySelector( '.debug' );
    this.applyFormDOM = block.querySelector( '.apply-form' );
    this.params.expand_offer = block.querySelector( 'input#url_offer' ).value;
    this.params.expand_offer = this.params.expand_offer.length > 0 ? parseInt( this.params.expand_offer) : null;
    this.params.list_page = block.querySelector( 'input#list_page' ).value;
    this.params.list_page = this.params.list_page.length > 0 ? parseInt( this.params.list_page) : 1;
    this.baseHref = window.location;
    this.loadActions();
    // this.loadSearchForm();
    this.loadOffers();

  }

  loadOffers() {
    this.debugDOM.classList.add( 'd-none' );
    console.log( 'loadOffers' );
    this.preloader( true );
    this.listDOM.innerHTML = '';
    let xhr = new XMLHttpRequest();
    console.log(this.baseHref.origin);
    xhr.open( 'GET',
        this.baseHref.origin + '/wp-json/epp/v1/job-offers/?lang='+this.debugDOM.getAttribute('data-lang')+'&params=' +
        JSON.stringify( this.params ) );
    xhr.send();
    xhr.onload = function() {
      if (xhr.status != 200) {
        console.error( `Error ${xhr.status}: ${xhr.statusText}` ); // e.g. 404: Not Found
        window.alert( `Error ${xhr.status}: ${xhr.statusText}` ); // e.g. 404: Not Found
      } else {
        try {
          this.listDOM.innerHTML = JSON.parse( xhr.responseText );
        } catch (e) {
          this.debugDOM.innerHTML = e;
          this.debugDOM.classList.remove( 'd-none' );
        }
        setTimeout( function() {
          this.preloader( false );
          this.scrollOffers();
        }.bind( this ), 25 );
      }
    }.bind( this );
    xhr.onerror = function() {
      console.log( 'Request failed' );
    };
  }
  //
  // loadSearchForm() {
  //   console.log( 'loadSearchForm' );
  //   var searchForm = this.block.querySelector( '.job-offers-search' );
  //   searchForm.querySelector( '.job-offers-search__filter-button' ).
  //       addEventListener( 'click', function( e ) {
  //         e.preventDefault();
  //         var search = searchForm.querySelector(
  //             '.job-offers-search__field--job-title' ).value;
  //         this.params.search = search.length > 0 ? search : null;
  //         this.params.list_page = 1;
  //
  //         var location = searchForm.querySelector(
  //             '.job-offers-search__field--job-location' ).value;
  //         this.params.location = location.length > 0
  //             ? parseInt( location )
  //             : null;
  //
  //         this.loadOffers();
  //       }.bind( this ) );
  // }

  loadActions() {
    this.block.addEventListener( 'click', function( e ) {
      if (e.target.classList.contains( 'offer-item__toggle-details' )) {
        var offer_id = parseInt(e.target.dataset.id);
        console.log( offer_id );
        var status = this.block.querySelector(
            '.offer-item--offer-' + offer_id + ' .offer-item__details' ).
            classList.
            toggle( 'active' );
        e.target.classList.toggle('active',status);

        this.setUrl(offer_id);
      }

      if (e.target.classList.contains( 'offer-item__apply-button' )) {
        var offer_id = e.target.dataset.id;
        var offer_title = this.block.querySelector(
            '.offer-item--offer-' + offer_id +
            ' .offer-item__title' ).innerHTML;
        this.applyFormDOM.querySelector(
            '.offer-name-title' ).innerHTML = offer_title;
        this.applyFormDOM.querySelector(
            'input[name="offer_name"]' ).value = offer_title + ' (#' +
            offer_id + ')';
        this.applyFormDOM.classList.add( 'active' );
        document.querySelector( 'body' ).classList.add( 'apply-form-run' );
      }

      if (e.target.classList.contains( 'apply-form' )) {
        this.applyFormDOM.classList.remove( 'active' );
        document.querySelector( 'body' ).classList.remove( 'apply-form-run' );
        $(':input.wpcf7-form-control',this.applyFormDOM).not('.wpcf7-submit').each(function(){$(this).val('');});
        $(this.applyFormDOM).find('.wpcf7-not-valid-tip').remove();
        $(".wpcf7-form").removeClass().addClass("wpcf7-form init");
        $(".wpcf7-form").attr("data-status", "init");
      }

      if (e.target.classList.contains('apply-form__close' )) {
        console.log('work');
        this.applyFormDOM.classList.remove( 'active' );
        document.querySelector( 'body' ).classList.remove( 'apply-form-run' );
        $(':input.wpcf7-form-control',this.applyFormDOM).not('.wpcf7-submit').each(function(){$(this).val('');});
        $(this.applyFormDOM).find('.wpcf7-not-valid-tip').remove();
        $(".wpcf7-form").removeClass().addClass("wpcf7-form init");
        $(".wpcf7-form").attr("data-status", "init");
      }

      if (e.target.classList.contains( 'pagination__link--active' )) {
        e.preventDefault();
        this.params.list_page = parseInt(e.target.dataset.id);
        this.params.expand_offer = null;
        this.loadOffers();
        this.block.scrollIntoView();
      }
    }.bind( this ) );

  }

  scrollOffers() {

    if (this.params.expand_offer !== null) {
      this.block.querySelector( '.offer-item--offer-' + this.params.expand_offer ).scrollIntoView();
      this.params.expand_offer = null;
    }
  }

  preloader( status ) {
    if (status === false) {
      this.preloaderDOM.classList.add( 'd-none' );
      this.listDOM.classList.add( 'ready' );
    } else {
      this.preloaderDOM.classList.remove( 'd-none' );
      this.listDOM.classList.add( 'loading' );
    }
  }

  setUrl(offer_id) {
      var params = new URLSearchParams(window.location.search);
      params.set('oferta', offer_id);
      var newUrl = this.baseHref.origin
          + this.baseHref.pathname
          + '?' + params.toString();
      window.history.pushState({path:newUrl},'',newUrl);
  }
}

